import bglogo from './product/backgammon/logo.png'
import bg from './product/backgammon/bg.jpg';
import sp from './product/spades/bg.jpg';
import ru from './product/rummy/bg.jpg';
import dm from './product/domino/bg.jpg';
import dmlogo from './product/domino/logo.png';
import languageMap from './language-map';
import BaseFormComponent from './product/Base-form.component';
import FormComponent from './product/backgammon/Form.component';

const initialValues = {
    fName: "",
    lName: "",
    nickname: "",
    phoneNumber: "",
    email: "",
    emailVerification: "",
    subject: "",
    message: "",
    did: "",
    uid: "",
    plt: "",
    lang: "",
    inid: "",
    fbid: "",
    tSe: "0"
}

export default function Factory(product = 'backgammon') {
    const options = {
        backgammon: { assets: { logo: bglogo, background: bg }, form: FormComponent, state: initialValues },
        spades: { assets: { logo: null, background: sp }, form: BaseFormComponent, state: initialValues },
        rummy: { assets: { logo: null, background: ru }, form: BaseFormComponent, state: initialValues },
        domino: { assets: { logo: dmlogo, background: dm }, form: BaseFormComponent, state: initialValues }
    }

    const assets = options[product]['assets'];
    const form = options[product]['form'];
    const langSchema = languageMap.get(product);
    const state = options[product]['state'];

    return {
        assets,
        langSchema,
        form,
        state
    }
}
